var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_1789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5073 14.9748C17.8387 13.158 18.4351 10.9055 18.177 8.66792C17.9189 6.43033 16.8255 4.37269 15.1155 2.90665C13.4055 1.44061 11.205 0.674302 8.95422 0.761028C6.70347 0.847753 4.56845 1.78112 2.97632 3.37439C1.38418 4.96767 0.452344 7.10335 0.367229 9.35416C0.282114 11.605 1.05 13.8049 2.51726 15.5139C3.98452 17.2229 6.04295 18.3148 8.28073 18.5713C10.5185 18.8277 12.7706 18.2298 14.5865 16.8971H14.5851C14.6263 16.9521 14.6703 17.0043 14.7198 17.0552L20.0136 22.349C20.2714 22.607 20.6212 22.752 20.9859 22.7521C21.3507 22.7522 21.7005 22.6075 21.9585 22.3496C22.2165 22.0918 22.3615 21.7421 22.3617 21.3773C22.3618 21.0126 22.217 20.6627 21.9592 20.4047L16.6655 15.111C16.6163 15.0612 16.5634 15.0152 16.5073 14.9735V14.9748ZM16.8621 9.68934C16.8621 10.6825 16.6665 11.6659 16.2864 12.5834C15.9064 13.5009 15.3493 14.3346 14.6471 15.0368C13.9448 15.7391 13.1111 16.2961 12.1936 16.6762C11.2761 17.0562 10.2927 17.2518 9.29958 17.2518C8.30645 17.2518 7.32306 17.0562 6.40553 16.6762C5.48801 16.2961 4.65432 15.7391 3.95208 15.0368C3.24984 14.3346 2.69279 13.5009 2.31274 12.5834C1.93268 11.6659 1.73707 10.6825 1.73707 9.68934C1.73707 7.68364 2.53384 5.76009 3.95208 4.34185C5.37032 2.92361 7.29388 2.12685 9.29958 2.12685C11.3053 2.12685 13.2288 2.92361 14.6471 4.34185C16.0653 5.76009 16.8621 7.68364 16.8621 9.68934Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_1789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.362061 0.751709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.35ca218db944e2da26c7e5d4d33d8568.svg";
export { ForwardRef as ReactComponent };